export const SHOULD_REMEMBER_USER = 'SHOULD_REMEMBER_USER';
export const CREDENTIAL_VALIDATION_FAILED = 'CREDENTIAL_VALIDATION_FAILED';
export const PASSWORD_CHANGE_ERROR = 'PASSWORD_CHANGE_ERROR';
export const REMEMBERED_DEVICE_DETAILS = 'REMEMBERED_DEVICE_DETAILS';
export const COMPLETED = 'COMPLETED';
export const RESOURCE_NOT_FOUND = 'RESOURCE_NOT_FOUND';
export const ACCESS_DENIED = 'access_denied';
export const VALIDATION_ERROR = 'VALIDATION_ERROR';
export const RESUME = 'RESUME';
export const X_EAM_AUTH_STATE = 'X-EAM-Authn-State';
export const LOGIN_URLS = [
  '/skymiles/login',
  '/skymiles/forgotLogin',
  '/skymiles/resetPassword',
  '/skymiles/selectVerificationMethod'
];
